import { z } from 'zod';
import { communicationsTrainingAssessmentResultEventName } from './communications-system-notification-adapter.contract.js';
export { communicationsTrainingAssessmentResultEventName };
// Consumer-owned duplicate of the small Training wire contract. Communications never
// imports Training implementation code, so either optional package remains removable.
export const communicationsTrainingAssessmentResultDeliveriesCapability = 'communications.training-assessment-result-deliveries.v1';
export const communicationsTrainingAssessmentResultPayloadSchema = z.strictObject({
    notificationKind: z.literal('training-assessment-result'),
    learnerMembershipId: z.string().uuid(),
    recipientRoleKeys: z.tuple([z.literal('manager'), z.literal('owner')]),
    requestedChannels: z.tuple([z.literal('email'), z.literal('in-app')]),
    courseId: z.string().uuid(),
    releaseId: z.string().uuid(),
    attemptId: z.string().uuid(),
    attemptNumber: z.number().int().positive(),
    courseTitle: z.string().trim().min(1).max(250),
    assessmentTitle: z.string().trim().min(1).max(250),
    scoreBasisPoints: z.number().int().min(0).max(10_000),
    passed: z.boolean(),
    submittedAt: z.string().datetime({ offset: true }),
    actionPath: z.literal('/training/grades'),
});
export const communicationsTrainingAssessmentResultDeliverySchema = z.strictObject({
    id: z.string().uuid(),
    sourceEventId: z.string().uuid(),
    sourceOccurredAt: z.string().datetime({ offset: true }),
    recipientMembershipId: z.string().uuid(),
    recipientRoleKeys: z.array(z.enum(['manager', 'owner'])).min(1).max(2),
    subjectMembershipId: z.string().uuid(),
    subjectDisplayName: z.string().trim().min(1).max(200),
    courseId: z.string().uuid(),
    releaseId: z.string().uuid(),
    attemptId: z.string().uuid(),
    attemptNumber: z.number().int().positive(),
    courseTitle: z.string().trim().min(1).max(250),
    assessmentTitle: z.string().trim().min(1).max(250),
    scoreBasisPoints: z.number().int().min(0).max(10_000),
    passed: z.boolean(),
    submittedAt: z.string().datetime({ offset: true }),
    channel: z.enum(['email', 'in-app']),
    state: z.literal('pending'),
    actionPath: z.literal('/training/grades'),
    createdAt: z.string().datetime({ offset: true }),
});
export const communicationsTrainingAssessmentResultDeliveryQuerySchema = z.strictObject({
    scope: z.enum(['mine', 'all']).default('mine'),
    channel: z.enum(['email', 'in-app']).nullable().default(null),
    passed: z.boolean().nullable().default(null),
    limit: z.number().int().min(1).max(200).default(50),
    offset: z.number().int().min(0).default(0),
});
export const communicationsTrainingAssessmentResultDeliveriesResponseSchema = z.strictObject({
    data: z.array(communicationsTrainingAssessmentResultDeliverySchema),
    page: z.strictObject({
        limit: z.number().int().positive(),
        offset: z.number().int().nonnegative(),
        returned: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=communications-training-assessment-result.contract.js.map